import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core'
import { parsePhoneNumber } from 'libphonenumber-js/min'

@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  /** Token of the locale application */
  public locale: string

  private _locale = inject(LOCALE_ID)

  constructor() {
    this.locale = this._locale.includes('-')
      ? this._locale.split('-')[0]
      : this._locale
  }

  /** Convert unformart phone number to phone number format fsor specific country */
  public transform(phoneValue: number | string): string {
    try {
      let phoneNumber = `${phoneValue}`
      const phoneNumberObj = parsePhoneNumber(phoneNumber || '', 'FR')

      if (phoneNumberObj && phoneNumberObj.country === 'FR') {
        phoneNumber = phoneNumberObj.formatNational()
      } else if (phoneNumberObj) {
        phoneNumber = phoneNumberObj.formatInternational()
      }

      return phoneNumber
    } catch (error) {
      return phoneValue as string
    }
  }
}
